var ids = 0;

module.exports = function () {
  return '_cssx' + (++ids);
};
module.exports.resetIDs = function () {
  ids = 0;
};



/*****************
 ** WEBPACK FOOTER
 ** ./packages/cssx/src/helpers/randomId.js
 ** module id = 16
 ** module chunks = 0
 **/